// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as UsersRouteImport } from './app/users'
import { Route as SettingsRouteImport } from './app/settings'
import { Route as RatecardRouteImport } from './app/ratecard'
import { Route as PrivacyRouteImport } from './app/privacy'
import { Route as NotificationsRouteImport } from './app/notifications'
import { Route as LoginRouteImport } from './app/login'
import { Route as LibraryRouteImport } from './app/library'
import { Route as LearningRouteImport } from './app/learning'
import { Route as GoogleRouteImport } from './app/google'
import { Route as ComplaintsRouteImport } from './app/complaints'
import { Route as IndexRouteImport } from './app/index'
import { Route as EstimatesIdRouteImport } from './app/estimates.$id'

const UsersRoute = UsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const RatecardRoute = RatecardRouteImport.update({
            id: '/ratecard',path: '/ratecard',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const NotificationsRoute = NotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LibraryRoute = LibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => rootRouteImport
          })
const LearningRoute = LearningRouteImport.update({
            id: '/learning',path: '/learning',getParentRoute: () => rootRouteImport
          })
const GoogleRoute = GoogleRouteImport.update({
            id: '/google',path: '/google',getParentRoute: () => rootRouteImport
          })
const ComplaintsRoute = ComplaintsRouteImport.update({
            id: '/complaints',path: '/complaints',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const EstimatesIdRoute = EstimatesIdRouteImport.update({
            id: '/estimates/$id',path: '/estimates/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ComplaintsRoute: ComplaintsRoute,GoogleRoute: GoogleRoute,LearningRoute: LearningRoute,LibraryRoute: LibraryRoute,LoginRoute: LoginRoute,NotificationsRoute: NotificationsRoute,PrivacyRoute: PrivacyRoute,RatecardRoute: RatecardRoute,SettingsRoute: SettingsRoute,UsersRoute: UsersRoute,EstimatesIdRoute: EstimatesIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)